export default __webpack_public_path__ + "static/media/img-1.ba2a7280.jpeg";